<template>
  <!--应用 CSS 属性 touch-action: none; 这样任何触摸事件都不会产生默认行为,但是 touch 事件照样触发。-->
  <div id="app" style="touch-action: none">
    <router-view/>
  </div>
</template>

<script>
  import {getCookie} from '@/utils/cookie'
  import permission from './permission'

  export default {
    name: 'App',
    // 登录页单独为静态页，故在vue项目初始化的时候请求用户信息并初始化
  }
</script>



// WEBPACK FOOTER //
// src/App.vue